// Dimensions and landmark positions of the pre-rendered hero assets
// (public/hero/bench.*). GENERATED by scripts/render-hero-assets.js
// (`yarn build-hero-assets`), from the live scene's own projection, so the
// DOM label lands on the MCU in the poster and the loop exactly as it does live.
const BENCH_ASSET = {
  "base": "/hero/bench",
  "width": 1300,
  "height": 900,
  "pad": {
    "x": 0.3278896369030961,
    "y": 0.45737059596674423
  },
  "mcu": {
    "x": 0.5340098322287294,
    "y": 0.5110520677123258
  }
};

export default BENCH_ASSET;
